// Utils
import { isImage } from '../../../../common/elements/utils/elementTypeUtils';
import { getElement } from '../../../../common/elements/utils/elementTraversalUtils';
import { isRouteParamEnabled } from './imageModalUtils';

// Selectors
import { getLocationQueryParam } from '../../../app/routingSelector';
import { getCurrentModalElementId } from '../../modal/elementModalCommonSelector';
import { getElements } from '../../selectors/elementsSelector';

// Types
import { ReduxState } from '../../../types/reduxTypes';

const getIsEditingDrawingQueryParam = getLocationQueryParam('editing-drawing');

/**
 * Checks if the image modal is currently open in drawing mode.
 */
const selectIsImageModalDrawingModeActive = (state: ReduxState): boolean => {
    const currentModalElementId = getCurrentModalElementId(state);

    if (!currentModalElementId) return false;
    if (!isRouteParamEnabled(getIsEditingDrawingQueryParam(state))) return false;

    const element = getElement(getElements(state), currentModalElementId);

    if (!element) return false;

    return isImage(element);
};

export default selectIsImageModalDrawingModeActive;
